<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>REGISTROS DE PAGAMENTOS SGTEC</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <slot name="controles"></slot>
                <totais-status
                    :totaisStatus="totaisStatus"
                    v-if="totaisStatus"
                ></totais-status>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentosComputados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <pagamento-inserir
                            :pagamentosServicos="pagamentosServicos"
                            @detalharPagamento="
                                $emit('detalhar-pagamento', $event)
                            "
                        ></pagamento-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="protocolo" slot-scope="data">
                        {{ data.protocolo }}
                        <span v-if="data.prioritario"
                            ><br /><app-status status="PRIORITÁRIO"></app-status
                        ></span>
                        <span v-if="data.especial"
                            ><br />
                            <app-status status="ESPECIAL"></app-status>
                        </span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoInserir from './PagamentoInserir'
import TotaisStatus from './TotaisStatus'

export default {
    props: {
        titulo: {
            type: String,
            default: () => 'PAGAMENTOS SGTEC'
        },

        pagamentos: {
            type: Array,
            default: () => []
        },

        totaisStatus: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        showFornecedor: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdEtapas',
                    label: 'Etapas',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdDespesas',
                    label: 'Despesas',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {},

    created() {
        if (!this.showFornecedor) {
            this.campos.splice(1, 1)
        }
    },

    computed: {
        pagamentosComputados() {
            return this.pagamentos.map(pagamento => ({
                ...pagamento,
                _rowVariant: pagamento.temEtapasAtrasadas ? 'danger' : null
            }))
        }
    },

    watch: {},

    components: {
        PagamentoInserir,
        TotaisStatus
    }
}
</script>
